<script src="https://apis.google.com/js/platform.js"></script>

<main class="security-container">

  <app-security-nav></app-security-nav>

  <router-outlet></router-outlet>

</main>
